import { render } from "./Main.vue?vue&type=template&id=ec9ffb2c"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\moritz.kretschmer\\Documents\\hiddenstorm\\hiddenstorm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__